import { ApiFormattedResponse } from "@models/api_formatted_response"
import { mutate, query } from "@utils/graphql"
import {
  CreateUserInput,
  DeleteUserInput,
  UpdateUserInput,
  User,
  UserResponse,
  UsersResponse
} from "__generated__/graphql"
import createUser from "__generated__/queries/mutations/createUser"
import deleteUser from "__generated__/queries/mutations/deleteUser"
import updateUser from "__generated__/queries/mutations/updateUser"
import users from "__generated__/queries/queries/users"

export async function getUsers(): Promise<ApiFormattedResponse<UsersResponse>> {
  const response = await query<{
    users?: UsersResponse
  }>({
    query: users
  })
  if (!response.isSuccess) {
    return { ...response, data: undefined }
  }
  return {
    isSuccess: true,
    data: { data: response?.data?.users?.data as User[] }
  }
}

export async function createUsers(
  data: CreateUserInput
): Promise<ApiFormattedResponse<UserResponse>> {
  const response = await mutate<{
    createUser?: UserResponse
  }>({
    mutation: createUser,
    variables: { data: data }
  })
  if (!response.isSuccess) {
    return { ...response, data: undefined }
  }
  return {
    isSuccess: true,
    data: { data: response?.data?.createUser?.data as User }
  }
}

export async function updateUsers(
  data: UpdateUserInput
): Promise<ApiFormattedResponse<UserResponse>> {
  const response = await mutate<{
    updateUser?: UserResponse
  }>({
    mutation: updateUser,
    variables: { data: data }
  })
  if (!response.isSuccess) {
    return { ...response, data: undefined }
  }
  return {
    isSuccess: true,
    data: { data: response?.data?.updateUser?.data as User }
  }
}

export async function deleteUsers(
  data: DeleteUserInput
): Promise<ApiFormattedResponse<UserResponse>> {
  const response = await mutate<{
    deleteUser?: UserResponse
  }>({
    mutation: deleteUser,
    variables: { data: { _id: data._id } }
  })
  if (!response.isSuccess) {
    return { ...response, data: undefined }
  }
  return {
    isSuccess: true,
    data: { data: response?.data?.deleteUser?.data as User }
  }
}
